import './Spinner.scss';

export function Spinner() {
  return (
    <div className="Spinner">
      <img src="/loader.gif" alt="spinner" />
    </div>
  );
}
